import React from 'react'
import Toggle from 'react-toggle'
import './react-toggle.scss'

const Index = props => <Toggle icons={false} {...props} />

export default Index
